import { useAPI } from '@pella/cosmos-react';
import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '../../utils/enums';

/**
 * Fetches team member data from the TeamMembersAPI by userid.
 * @param {string} [userid]
 */
export const useTeamMemberByUserId = (userid) => {
  const { api, apiReady } = useAPI();
  const queriesEnabled = Boolean(userid && apiReady);

  return useQuery({
    queryKey: [QUERY_KEYS.TEAM_MEMBER_DATA, userid],
    queryFn: () => api.teamMember.getTeamMemberByUserId(String(userid)),
    enabled: queriesEnabled,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};
